import { render, staticRenderFns } from "./WidgetManager.vue?vue&type=template&id=20b98174&lang=pug&"
import script from "./WidgetManager.vue?vue&type=script&lang=js&"
export * from "./WidgetManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b98174')) {
      api.createRecord('20b98174', component.options)
    } else {
      api.reload('20b98174', component.options)
    }
    module.hot.accept("./WidgetManager.vue?vue&type=template&id=20b98174&lang=pug&", function () {
      api.rerender('20b98174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/widget/WidgetManager.vue"
export default component.exports